module.exports = "img/flags/MN.82de49b.png";